module.exports = __webpack_public_path__ + "img/dd-logo-honda-w.4b03fa60.png";